angular.module("autoremind.templates").directive("adminTemplatesUsers", [
    "templateService",
    "$timeout",
    "dialogs",
    "eventSharingService",
    function (templateService, $timeout, dialogs, eventSharingService) {
        return {
            restrict: "E",
            templateUrl: "app/admin/templates/admin-templates-users.html",
            scope: {
                userId: "=",
            },
            link: function ($scope, element, attrs) {
                element.addClass("adminTemplatesUsers");
                $scope.templateService = templateService;
                $scope.templateService.userModel.userId = $scope.userId;
                $scope.templateService.userModel.templates = [];
                $scope.viewModel = {
                    messagesSort: { column: "createdInt", descending: true },
                };
                $scope.canEditDefault = eventSharingService.hasPermission(['admin:template:editdefault']);
                $scope.userTemplatesData = [
                    {
                        name: "Reminder",
                        file: "86/reminder.html",
                        enabled: true,
                        master: true,
                    },
                    {
                        name: "Confirm",
                        file: "standart/confirm.html",
                        enabled: true,
                        master: true,
                    },
                    {
                        name: "Birthday",
                        file: "86/birthday.html",
                        enabled: true,
                        master: true,
                    },
                ];
                $scope.messageDataFilter = function (messageData) {
                    if ($scope.viewModel.selectedCategory === "all" ||
                        $scope.viewModel.selectedCategory === "")
                        return true;
                    if (messageData.category === $scope.viewModel.selectedCategory) {
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                $scope.changeSorting = function (column) {
                    if ($scope.viewModel.messagesSort.column === column) {
                        $scope.viewModel.messagesSort.descending =
                            !$scope.viewModel.messagesSort.descending;
                    }
                    else {
                        $scope.viewModel.messagesSort.column = column;
                        $scope.viewModel.messagesSort.descending = false;
                    }
                };
                $scope.loadUserTemplates = function () {
                    $scope.templateService.getTemplatesByUserId();
                };
                $scope.$watch("userId", function () {
                    $scope.loadUserTemplates();
                });
                $scope.changeTemplate = function (template, field) {
                    template[field] = true;
                    $scope.templateService.setTemplateToUser(false, template);
                };
                $scope.editTemplateModelDialog = function (template) {
                    $scope.selectTemplate(template, "name");
                    $scope.templateService.editTemplateModelDialog(template, undefined, false, false);
                };
                $scope.removeUserTemplate = function (template) {
                    templateService.removeUserTemplate(template);
                };
                $scope.selectTemplate = function (template) {
                    if (!angular.isUndefined(templateService.model.currentTemplate) &&
                        null !== templateService.model.currentTemplate) {
                        if (templateService.model.currentTemplate.templateId !== template.templateId) {
                            $scope.viewModel.editableColumn = '';
                        }
                    }
                    templateService.model.currentTemplate = angular.copy(template);
                };
                $scope.upload = function (template) {
                    $scope.selectTemplate(template);
                    if (template.countOfTemplateFileUsages &&
                        template.countOfTemplateFileUsages > 0) {
                        $scope.templateService.showErrorIfFileIsUsed().then(function () {
                            $scope.uploadTemplate(template, true);
                        });
                        return;
                    }
                    $scope.uploadTemplate(template);
                };
                $scope.uploadTemplate = function (template, isCustomTemplate) {
                    $scope.templateService
                        .uploadTemplate(template, isCustomTemplate)
                        .then(function () {
                        // $scope.filterWasChanged(true);
                    });
                };
                $scope.openFieldToEdit = function (template, column) {
                    console.log("openFieldEdit from template users <<<<");
                    $scope.viewModel.editableColumn = column;
                };
                $scope.showMessageIfEditedFieldIsEmpty = function (template, oldTemplate, field) {
                    var msg = "";
                    var column = "";
                    switch (field) {
                        case "templateDisplayName":
                            msg = "You need to enter a name for the template.";
                            column = "name";
                            break;
                        case "templateFileRef":
                            column = "filename";
                            msg = "You need to enter a file name for the template.";
                            break;
                        case "templateName":
                            column = "templateName";
                            msg = "Template name cannot be blank or not start with UserId.";
                            break;
                    }
                    $scope.viewModel.editableColumn = column;
                    dialogs.notify("Warning", msg).result.then(function () {
                        template.isEdited = false;
                        template[field] = oldTemplate[field];
                    });
                };
                $scope.changeTemplateField = function (template, field) {
                    if (!template.isEdited) {
                        return;
                    }
                    if (template.editingTemplate) {
                        return;
                    }
                    $timeout(function () {
                        if (template.templateDisplayName === "") {
                            $scope.showMessageIfEditedFieldIsEmpty(template, angular.copy($scope.templateService.model.currentTemplate), "templateDisplayName");
                            return;
                        }
                        if (template.templateFileRef === "") {
                            $scope.showMessageIfEditedFieldIsEmpty(template, angular.copy($scope.templateService.model.currentTemplate), "templateFileRef");
                            return;
                        }
                        if (template.templateName === '' ||
                            (!template.templateName.toLowerCase().match(/^\d/) && !$scope.canEditDefault)) {
                            $scope.showMessageIfEditedFieldIsEmpty(template, angular.copy($scope.templateService.model.currentTemplate), "templateName");
                            return;
                        }
                        //                console.log('template', template, $scope.templateService.model.currentTemplate)
                        $scope.templateService.changeTemplate(template, angular.copy($scope.templateService.model.currentTemplate));
                    }, 50);
                };
                $scope.cancelEditing = function (template, column) {
                    $scope.viewModel.editableColumn = null;
                    template[column] =
                        $scope.templateService.model.currentTemplate[column];
                    template.isEdited = false;
                };
                $scope.cloneToTwilio = function (template) {
                    if (template.templateFileRef.indexOf('twilio') === -1) {
                        templateService.cloneToTwilio(template);
                    }
                };
            },
        };
    },
]);
//# sourceMappingURL=admin-templates-users.js.map